export default `/* Ids Tree Component */
@keyframes keyframes-rotate-forward {
  0% {
    transform: rotate(-90deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
@keyframes keyframes-rotate-backward {
  0% {
    transform: rotate(45deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
:host {
  display: inline-block;
}

.ids-tree ids-badge::part(badge) {
  border-width: var(--ids-border-width-none);
  margin: 0;
  margin-inline-end: 8px;
}
.ids-tree ::slotted(ids-badge) {
  align-self: center;
}
.ids-tree {
  list-style-type: none;
  margin-bottom: var(--ids-space-4xs);
  display: inline-block;
  margin-block-start: 0;
  margin-block-end: 0;
  padding-inline-start: 0;
}

ids-badge::part(badge) {
  border-width: var(--ids-border-width-none);
  margin: 0;
  margin-inline-end: 8px;
}

::slotted(ids-badge) {
  align-self: center;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2J1aWxkcy9pbmZvci1kZXNpZ24vZW50ZXJwcmlzZS13Yy9zcmMvY29tcG9uZW50cy9pZHMtdHJlZSIsInNvdXJjZXMiOlsiaWRzLXRyZWUuc2NzcyIsImlkcy10cmVlLXNoYXJlZC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0FDQ0E7RUFDRTtJQUNFOztFQUdGO0lBQ0U7OztBQUlKO0VBQ0U7SUFDRTs7RUFHRjtJQUNFOzs7QURkSjtFQUNFOzs7QUNtQkE7RUFDRTtFQUNBO0VBQ0E7O0FBR0Y7RUFDRTs7QUR2Qko7RUFHRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7OztBQ1FBO0VBQ0U7RUFDQTtFQUNBOzs7QUFHRjtFQUNFIiwic291cmNlc0NvbnRlbnQiOlsiLyogSWRzIFRyZWUgQ29tcG9uZW50ICovXG5AdXNlICcuL2lkcy10cmVlLXNoYXJlZCcgYXMgKjtcblxuOmhvc3Qge1xuICBkaXNwbGF5OiBpbmxpbmUtYmxvY2s7XG59XG5cbi5pZHMtdHJlZSB7XG4gIEBpbmNsdWRlIHRyZWUtbm9kZS1iYWRnZSgpO1xuXG4gIGxpc3Qtc3R5bGUtdHlwZTogbm9uZTtcbiAgbWFyZ2luLWJvdHRvbTogdmFyKC0taWRzLXNwYWNlLTR4cyk7XG4gIGRpc3BsYXk6IGlubGluZS1ibG9jaztcbiAgbWFyZ2luLWJsb2NrLXN0YXJ0OiAwO1xuICBtYXJnaW4tYmxvY2stZW5kOiAwO1xuICBwYWRkaW5nLWlubGluZS1zdGFydDogMDtcbn1cblxuQGluY2x1ZGUgdHJlZS1ub2RlLWJhZGdlKCk7XG4iLCIvLyBLZXlmcmFtZXMgZm9yIHRoZSBcInBsdXNtaW51c1wiIGljb24gYW5pbWF0aW9uXG5Aa2V5ZnJhbWVzIGtleWZyYW1lcy1yb3RhdGUtZm9yd2FyZCB7XG4gIDAlIHtcbiAgICB0cmFuc2Zvcm06IHJvdGF0ZSgtOTBkZWcpO1xuICB9XG5cbiAgMTAwJSB7XG4gICAgdHJhbnNmb3JtOiByb3RhdGUoMGRlZyk7XG4gIH1cbn1cblxuQGtleWZyYW1lcyBrZXlmcmFtZXMtcm90YXRlLWJhY2t3YXJkIHtcbiAgMCUge1xuICAgIHRyYW5zZm9ybTogcm90YXRlKDQ1ZGVnKTtcbiAgfVxuXG4gIDEwMCUge1xuICAgIHRyYW5zZm9ybTogcm90YXRlKDBkZWcpO1xuICB9XG59XG5cbi8vIEFkanVzdCBiYWRnZSBydWxlcyBmb3IgdHJlZSBub2RlXG5AbWl4aW4gdHJlZS1ub2RlLWJhZGdlKCkge1xuICBpZHMtYmFkZ2U6OnBhcnQoYmFkZ2UpIHtcbiAgICBib3JkZXItd2lkdGg6IHZhcigtLWlkcy1ib3JkZXItd2lkdGgtbm9uZSk7XG4gICAgbWFyZ2luOiAwO1xuICAgIG1hcmdpbi1pbmxpbmUtZW5kOiA4cHg7XG4gIH1cblxuICA6OnNsb3R0ZWQoaWRzLWJhZGdlKSB7XG4gICAgYWxpZ24tc2VsZjogY2VudGVyO1xuICB9XG59XG4iXX0= */`;
